import locationApi from '@/api/admin/locationApi'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'

function useCheckOverlay(interfaceId: any) {
  return useQuery([[queryKeys.location], interfaceId], async () => {
    if (!interfaceId) return null
    const { data } = await locationApi.checkFloorOverlay(interfaceId.toString())

    if (!data) return data

    return data
  })
}

export default useCheckOverlay
